import { Checkbox, FormControlLabel } from "@mui/material";
import type { FC } from "react";
import { memo } from "react";
import type { CheckBoxProps } from "./checkbox.types";
import { CheckBoxContainer } from "./checkbox.styles";

export const CheckBox: FC<CheckBoxProps> = memo(
  ({ label, disabled, checked, onChange, id, value }: CheckBoxProps) => {
    return (
      <CheckBoxContainer>
        <FormControlLabel
          control={
            <Checkbox
              id={id}
              value={value}
              checked={checked}
              disabled={disabled}
              onChange={onChange}
            />
          }
          label={label}
        />
      </CheckBoxContainer>
    );
  }
);
